import React, { useState } from 'react';
import { UserIcon, LockIcon } from 'lucide-react';
interface LoginScreenProps {
  onLogin: () => void;
}
export function LoginScreen({
  onLogin
}: LoginScreenProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onLogin();
  };
  return <div className="flex flex-col h-full w-full bg-white px-6 py-10 overflow-y-auto" data-id="element-182">
      <div className="flex flex-col items-center mt-8 mb-10" data-id="element-183">
        <img src="https://cdn.magicpatterns.com/uploads/wszHE4itFVKfiMMSe74Psk/logohospigen.png" alt="Logo HSJD" className="w-[180px] h-auto object-contain mb-6" data-id="element-184" />
        <h1 className="text-2xl font-bold text-gray-900" style={{
        color: '#134073'
      }} data-id="element-185">
          Iniciar Sesión
        </h1>
        <p className="text-gray-500 mt-1" data-id="element-186">Sistema de Control de Lavandería</p>
      </div>

      <form onSubmit={handleSubmit} className="flex flex-col gap-5 flex-1" data-id="element-187">
        <div className="relative" data-id="element-188">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-189">
            <UserIcon className="h-5 w-5 text-gray-400" data-id="element-190" />
          </div>
          <input type="text" placeholder="Usuario" className="block w-full pl-11 pr-4 py-3 h-14 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:border-transparent text-lg" style={{
          focusRingColor: '#3d99d2'
        }} value={username} onChange={e => setUsername(e.target.value)} required data-id="element-191" />
        </div>

        <div className="relative" data-id="element-192">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-193">
            <LockIcon className="h-5 w-5 text-gray-400" data-id="element-194" />
          </div>
          <input type="password" placeholder="Contraseña" className="block w-full pl-11 pr-4 py-3 h-14 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:border-transparent text-lg" value={password} onChange={e => setPassword(e.target.value)} required data-id="element-195" />
        </div>

        <div className="flex items-center justify-between mt-2" data-id="element-196">
          <label className="flex items-center gap-2" data-id="element-197">
            <input type="checkbox" className="w-5 h-5 rounded border-gray-300 text-blue-600 focus:ring-blue-500" data-id="element-198" />
            <span className="text-gray-600 font-medium" data-id="element-199">Recordarme</span>
          </label>
          <button type="button" className="text-sm font-semibold" style={{
          color: '#3d99d2'
        }} data-id="element-200">
            ¿Olvidé mi contraseña?
          </button>
        </div>

        <button type="submit" className="w-full h-14 rounded-xl text-white font-bold text-lg mt-6 shadow-lg active:scale-[0.98] transition-transform" style={{
        backgroundColor: '#134073'
      }} data-id="element-201">
          Ingresar
        </button>
      </form>

      <div className="mt-auto pt-8 text-center" data-id="element-202">
        <p className="text-gray-400 text-sm font-medium" data-id="element-203">
          Lavandería Hospitalaria v1.0
        </p>
      </div>
    </div>;
}